import { connect } from 'react-redux';
import EntriesGrid from 'components/EntriesGrid/EntriesGrid';
import MainEntryItem from './MainEntryItem';
import { getSortedGroups } from '../selectors';
import {
  entrySelected,
  entryUnselected,
  toggleSortOrder,
  changeReadFilter,
  groupsSelected,
  entriesOpened
} from '../actions';

// For filter entries
const mapStateToPropsEntries = ({ data, scene }, ownProps) => {
  return {
    ...ownProps,
    entriesObj: data.entries,
    entriesSelected: scene.main.entriesSelected,
    groupsSelected: scene.main.groupsSelected,
    readFilter: scene.main.readFilter,
    sortedByTags: scene.main.sortedByTags,
    entryGroups: getSortedGroups({ data, scene }),
    EntryItemComponent: MainEntryItem
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleSelected: (id) => { dispatch(entrySelected(id)) },
    handleUnselected: (id) => { dispatch(entryUnselected(id)) },
    handleChangeReadFilter: (filter) => { dispatch(changeReadFilter(filter)) },
    handleToggleSortOrder: () => { dispatch(toggleSortOrder()) },
    handleGroupsSelected: (groups) => { dispatch(groupsSelected(groups)) },
    handleEntriesOpened: (entryIds, method) => { dispatch(entriesOpened(entryIds, method)) }
  }
}

/*------------------------------------------------------- */

const FilterContainer = {
  EntriesGrid:
    connect(
      mapStateToPropsEntries,
      mapDispatchToProps
    )(EntriesGrid)
};

export default FilterContainer;



// WEBPACK FOOTER //
// ./src/scenes/Main/components/FilterContainers.js